import { Cell } from "react-table";
import { BuildingModel } from "src/api/building/building-types";
import { BaseTooltip } from "src/components/BaseTooltip";

export const BuildingDateCell = (props: Cell<BuildingModel>) => {
  return <BaseTooltip contents={props?.value} type="date" />;
};
